export default {"src":"/_next/static/media/toothCrack_24.94eb382b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};